import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi everyone! I’m <span className="purple">Ankit Sigdel</span>{" "}
            from <span className="purple">Kathmandu, Nepal</span>.
            <br />
            I’m currently pursuing as a{" "}
            <span className="purple">Bachelor’s in Computer Engineering</span> at{" "}
            <span className="purple">Kathmandu University (KU)</span>.
            <br />
            
My passion for technology and problem-solving has driven me to explore various programming languages and frameworks. I enjoy working on projects that challenge me to think critically and creatively.
            <br />
            <br />
            Outside of academics, I enjoy activities that keep me motivated and growing:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games 🎮
            </li>
            <li className="about-activity">
              <ImPointRight /> Building Projects & Exploring New Technologies 💻
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling and Exploring New Places 🌍
            </li>
            <li className="about-activity">
              <ImPointRight />  Exploring Ideas and Opportunities 🌍
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Code with purpose. Build with passion."{" "}
          </p>
          <footer className="blockquote-footer">Ankit Sigdel</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
